export const itemReducer = function (state = 0, action) {
  switch (action.type) {
    case "getItems":
      return state + 1;
    case "saveTransaction":
      return state - 1;
    default:
      return state;
  }
};
